module.exports = __webpack_public_path__ + "img/ar_hash_down_s.59767030.svg";